import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { Directive, ElementRef, EventEmitter, Inject, PLATFORM_ID, AfterViewInit, Output, Renderer2, OnInit } from '@angular/core';
import { timer } from 'rxjs';
import { loadLazyJsFile } from 'src/app/util';

@Directive({
  selector: '[tmLazies]'
})
export class LaziesDirective implements AfterViewInit, OnInit {
  /** lazySizes 插件初始化完成後觸發 */
  static pulginInit = new EventEmitter<void>();
  /** 全域的 lazySizes 插件初始化完成 */
  static isPluginInit = false;
  /** 全域的 lazySizes 插件在正初始化中 */
  static isPluginIniting = false;
  /** 使用 lazySizes 套件來加載圖片，否則若支援 browser lavel 的 lazy loading 就用 browser 的 */
  static useOnlyLazies = false;
  /** 是否渲染端為瀏覽器 */
  protected isBrowser: boolean;
  /** 可以開始使用元件了 */
  canInit = false;
  /** 指令初始化完成 */
  @Output() init = new EventEmitter<void>();
  /** 載入插件的方法 */
  static loadPlugin = (renderer: Renderer2) => {
    LaziesDirective.isPluginIniting = true;
    loadLazyJsFile(renderer, 'lazysizesScript', '/assets/lazysizes/lazysizes.min.js');
    checkPluginCanUse(() => {
      LaziesDirective.isPluginInit = true;
      LaziesDirective.isPluginIniting = false;
      LaziesDirective.pulginInit.emit();
      LaziesDirective.pulginInit.complete();
    });
  }

  constructor(
    @Inject(PLATFORM_ID) protected platformId: any,
    protected el: ElementRef,
    protected renderer: Renderer2,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    if (this.isBrowser) {
      if (!LaziesDirective.isPluginInit && !LaziesDirective.isPluginIniting) {
        if (isPluginLoaded()) {
          LaziesDirective.isPluginInit = true;
        } else {
          LaziesDirective.loadPlugin(renderer);
        }
      }
    }
  }

  ngOnInit() {
    if (!this.isBrowser) { addNoScriptImage(this.renderer, this.el.nativeElement); }
  }

  ngAfterViewInit() {
    const imgEl = this.el.nativeElement as HTMLImageElement;
    if (this.isBrowser) {
      const lostSizeSpec = !(imgEl.getAttribute('width') && imgEl.getAttribute('height')) && !(imgEl.style.width && imgEl.style.height);

      if (!LaziesDirective.isPluginInit) {
        LaziesDirective.pulginInit.subscribe(() => {
          this.initLaziesDom(imgEl, lostSizeSpec);
          this.canInit = true;
        });
      } else {
        setTimeout(() => {
          this.initLaziesDom(imgEl, lostSizeSpec);
          this.canInit = true;
        }, 0);
      }
    }
  }

  initLaziesDom(el: HTMLImageElement, lostSizeSpec: boolean) {
    if (!el.classList.contains('lazyload')) {
      el.classList.add('lazyload');
      if (!el.dataset.src) {
        el.dataset.src = el.src;
        el.src = '';
      }
      if (lostSizeSpec) {
        const onLoadHandler = (e) => {
          const cs = getComputedStyle(el, null);
          if (parseFloat(cs['minHeight'])) {
            el.style.minHeight = 'unset';
          }
          el.removeEventListener('load', onLoadHandler);
        };
        el.addEventListener('load', onLoadHandler);
      }
    }
  }
}

function isPluginLoaded() {
  return window['lazySizes'];
}

const checkPluginCanUse = (cb: () => void) => {
  const cpTmSubc = timer(0, 300).subscribe(t => {
    if (isPluginLoaded()) {
      cpTmSubc.unsubscribe();
      cb();
    }
  });
};

export const addNoScriptImage = (renderer: Renderer2, el: HTMLImageElement) => {
  const dataSrc = el.getAttribute('data-src');
  if (el.parentElement && dataSrc) {
    const nScript = renderer.createElement('noscript');
    const img = renderer.createElement('img');
    renderer.setAttribute(img, 'src', dataSrc);
    renderer.appendChild(nScript, img);
    renderer.insertBefore(el.parentElement, nScript, el);
  }
};
